import { useCallback, useEffect, useState } from "react";

let deferredPromptGlobal = null;
const promptListeners = new Set();

const notifyPromptListeners = (event) => {
  deferredPromptGlobal = event;
  promptListeners.forEach((fn) => fn(event));
};

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    notifyPromptListeners(event);
  });
  window.addEventListener("appinstalled", () => {
    notifyPromptListeners(null);
  });
}

export const isStandaloneDisplay = () => {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
};

export const isIosDevice = () => {
  if (typeof navigator === "undefined") return false;
  return /iphone|ipad|ipod/i.test(navigator.userAgent);
};

export default function usePwaInstall() {
  const [promptEvent, setPromptEvent] = useState(deferredPromptGlobal);
  const [isStandalone, setIsStandalone] = useState(isStandaloneDisplay);

  useEffect(() => {
    const onPrompt = (event) => setPromptEvent(event);
    promptListeners.add(onPrompt);

    const media = window.matchMedia("(display-mode: standalone)");
    const onDisplayMode = () => setIsStandalone(isStandaloneDisplay());
    if (media.addEventListener) {
      media.addEventListener("change", onDisplayMode);
    } else {
      media.addListener(onDisplayMode);
    }

    return () => {
      promptListeners.delete(onPrompt);
      if (media.removeEventListener) {
        media.removeEventListener("change", onDisplayMode);
      } else {
        media.removeListener(onDisplayMode);
      }
    };
  }, []);

  const promptInstall = useCallback(async () => {
    if (!promptEvent || typeof promptEvent.prompt !== "function") {
      return { outcome: "unavailable" };
    }
    promptEvent.prompt();
    const choice = await promptEvent.userChoice;
    notifyPromptListeners(null);
    return choice;
  }, [promptEvent]);

  return {
    canInstall: Boolean(promptEvent),
    promptInstall,
    isStandalone,
    isIos: isIosDevice(),
  };
}
